<template>
  <div class="page" :style="themeStyle">
    <div v-if="!loaded" class="loading">Loading</div>
    <div v-if="loaded" class="root">

      <!-- Aurora BG -->
      <div class="aurora-bg" aria-hidden="true">
        <div class="aurora-band a1"></div>
        <div class="aurora-band a2"></div>
        <div class="aurora-band a3"></div>
      </div>

      <!-- Header bar -->
      <header class="header">
        <img v-if="loinfo && loinfo.main_logo" :src="loinfo.main_logo" class="header-logo" />
        <div class="header-center">
          <span class="header-byline">{{ loName }}</span>
          <span class="sep">✦</span>
          <span class="header-byline muted">{{ realtorName }}</span>
        </div>
        <a class="header-cta" :href="applyRightLink">{{ heroPrimaryText }}</a>
      </header>

      <!-- Magazine grid -->
      <main class="mag-grid">

        <!-- Big feature article style -->
        <article class="feature-article">
          <div class="fa-label">
         
          </div>
          <h1 class="fa-h1" v-html="heroH1Html"></h1>
          <div class="fa-rule"></div>
          <p class="fa-body">{{ heroBody }}</p>
          <div class="fa-btns">
            <a class="fa-btn-primary" :href="applyRightLink">{{ heroPrimaryText }}</a>
            <a v-if="applyLeftLink" class="fa-btn-sec" :href="applyLeftLink">{{ heroSecondaryText }}</a>
          </div>
        </article>

        <!-- Right column cards -->
        <div class="right-col">
          <div class="pro-card lo-pro">
            <div class="pro-stripe lo-stripe"></div>
            <div class="pro-inner">
              <div class="pro-img-wrap">
                <img v-if="loinfo && loinfo.lo_image" :src="loinfo.lo_image" class="pro-img" />
                <div class="pro-ring lo-ring"></div>
              </div>
              <div class="pro-details">
                <span class="pro-tag">Loan Officer</span>
                <div class="pro-name">{{ loName }}</div>
                <div class="pro-title">{{ loTitle }}</div>
                <div v-if="loinfo && loinfo.nmls" class="pro-nmls">NMLS {{ (loinfo.nmls || "").trim() }}</div>
              </div>
            </div>
            <div class="pro-footer">
              <a v-if="loinfo && loinfo.phone_number" :href="'tel:' + loinfo.phone_number" class="pro-contact lo-ct">{{ loinfo.phone_number }}</a>
              <a v-if="loinfo && loinfo.email" :href="'mailto:' + loinfo.email" class="pro-contact lo-ct">{{ loinfo.email }}</a>
              <a class="pro-apply" :href="applyRightLink">{{ heroPrimaryText }}</a>
            </div>
          </div>

          <div class="pro-card re-pro">
            <div class="pro-stripe re-stripe"></div>
            <div class="pro-inner">
              <div class="pro-img-wrap">
                <img v-if="realtor && realtor.headshot_url" :src="realtor.headshot_url" class="pro-img" />
                <div class="pro-ring re-ring"></div>
              </div>
              <div class="pro-details">
                <span class="pro-tag re-tag">Partner</span>
                <div class="pro-name">{{ realtorName }}</div>
                <div class="pro-title">{{ realtor && realtor.brokerage_name }}</div>
              </div>
            </div>
            <div class="pro-footer">
              <a v-if="realtor && realtor.phone_number" :href="'tel:' + realtor.phone_number" class="pro-contact re-ct">{{ realtor.phone_number }}</a>
              <a v-if="realtor && realtor.email" :href="'mailto:' + realtor.email" class="pro-contact re-ct">{{ realtor.email }}</a>
              <a v-if="realtor && realtor.website_url" :href="realtor.website_url" class="pro-contact re-ct" target="_blank" rel="noreferrer">Visit Website →</a>
            </div>
          </div>
        </div>

      </main>

    </div>
  </div>
</template>

<script>
import coBrandMixin from "../../mixins/coBrandMixin.js";
const BRAND_COLORS = {
  zonalending: { primary: "#eb610a", accent: "#646363" },
  radiantmortgage: { primary: "#1C1F39", accent: "#DB9457" },
  conradmortgage: { primary: "#4a4b4b", accent: "#d4af37" },
  theimgteam: { primary: "#ff6633", accent: "#4a4c54" },
  responsivemortgage: { primary: "#07212c", accent: "#FF7F47" },
  kpmortgage: { primary: "#0D2821", accent: "#34BFC6" },
  ignitemortgage: { primary: "#000000", accent: "#00b1eb" },
  goldstarfinancial: { primary: "#0b1726", accent: "#c69c39" },
};
function getBrandKey(email) {
  if (!email) return null;
  return email.slice(email.indexOf("@") + 1).toLowerCase().split(".")[0] || null;
}
export default {
  name: "CoBrandAurora",
  mixins: [coBrandMixin],
  computed: {
    brandKey() { const k = getBrandKey(this.loinfo?.email); return (k && BRAND_COLORS[k]) ? k : "goldstarfinancial"; },
    palette() { return BRAND_COLORS[this.brandKey] || BRAND_COLORS.goldstarfinancial; },
    themeStyle() { return { "--p": this.palette.primary, "--a": this.palette.accent }; },
    heroH1Html() {
      const h = (this.realtor?.header1 || this.loinfo?.header1 || "").trim();
      if (!h) return "Ready to get<br/><em>started?</em>";
      const parts = h.split(",");
      if (parts.length > 1) return `${parts[0].trim()}<br/><em>${parts.slice(1).join(",").trim()}</em>`;
      return h;
    },
    heroPrimaryText() { return this.loinfo?.right_button_text || "Apply Now"; },
    heroSecondaryText() { return this.loinfo?.left_button_text || "Schedule Appointment"; },
    heroBody() {
      const m = (this.realtor?.main || this.loinfo?.main || "").trim();
      if (m) return m;
      return [this.loinfo?.text_section_body_p1, this.loinfo?.text_section_body_p2].filter(Boolean).join(" ").trim()
        || this.loinfo?.footer_slogan || "Start your application in minutes and we'll guide you from application through closing.";
    },
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;700&family=DM+Serif+Display:ital@0;1&display=swap');

.page {
  min-height: 100vh;
  background: #0d0e1a;
  color: #dde2ef;
  font-family: 'DM Sans', sans-serif;
  --p: #0b1726;
  --a: #c69c39;
  --bg: #0d0e1a;
  --card-bg: rgba(255,255,255,0.05);
  --border: rgba(255,255,255,0.08);
  --muted: #8890aa;
  overflow: hidden;
  position: relative;
}
.root { position: relative; z-index: 1; display: flex; flex-direction: column; min-height: 100vh; }

/* AURORA */
.aurora-bg { position: fixed; inset: 0; pointer-events: none; z-index: 0; overflow: hidden; }
.aurora-band { position: absolute; border-radius: 50%; filter: blur(100px); opacity: 0.2; }
.a1 { width: 700px; height: 300px; background: linear-gradient(90deg, var(--p), #2a4fa8); top: -80px; left: 10%; animation: drift 12s ease-in-out infinite alternate; }
.a2 { width: 500px; height: 250px; background: linear-gradient(90deg, #2a8a5a, var(--a)); top: 20px; right: -5%; animation: drift 15s ease-in-out infinite alternate-reverse; }
.a3 { width: 400px; height: 200px; background: linear-gradient(90deg, #5a2a8a, var(--p)); bottom: 10%; left: 20%; animation: drift 18s ease-in-out infinite alternate; }
@keyframes drift { from { transform: translateX(-30px) translateY(0); } to { transform: translateX(30px) translateY(-20px); } }

/* HEADER */
.header { position: relative; z-index: 10; display: flex; align-items: center; justify-content: space-between; padding: 20px 52px; border-bottom: 1px solid var(--border); }
.header-logo { width: 140px; max-height:72px; object-fit: contain;  }
.header-center { display: flex; align-items: center; gap: 10px; }
.header-byline { font-size: 12px; color: rgba(221,226,239,0.7); }
.header-byline.muted { opacity: 0.5; }
.sep { color: var(--a); font-size: 10px; }
.header-cta { font-size: 12px; font-weight: 500; text-decoration: none; color: #0d0e1a; background: var(--a); padding: 9px 22px; border-radius: 6px; transition: opacity 0.2s; }
.header-cta:hover { opacity: 0.85; }

/* MAG GRID */
.mag-grid { position: relative; z-index: 1; display: grid; grid-template-columns: 1fr 340px; max-width: 1160px; margin: 0 auto; width: 100%; padding: 64px 52px 52px; gap: 52px; align-items: start; }

/* FEATURE */
.feature-article { }
.fa-label { display: flex; align-items: center; gap: 10px; margin-bottom: 24px; }
.fa-issue { font-size: 10px; font-weight: 500; letter-spacing: 0.22em; text-transform: uppercase; color: var(--a); }
.fa-h1 { font-family: 'DM Serif Display', serif; font-size: clamp(40px, 5.5vw, 72px); line-height: 1.06; color: #f0f4ff; margin: 0 0 24px; }
.fa-h1 em { color: var(--a); font-style: italic; }
.fa-rule { width: 48px; height: 3px; background: var(--a); margin-bottom: 22px; border-radius: 2px; }
.fa-body { font-size: 15px; line-height: 1.8; color: var(--muted); margin-bottom: 32px; font-weight: 300; max-width: 480px; }
.fa-btns { display: flex; gap: 10px; flex-wrap: wrap; }
.fa-btn-primary { font-size: 13px; font-weight: 600; text-decoration: none; background: var(--a); color: #0d0e1a; padding: 13px 28px; border-radius: 8px; transition: opacity 0.2s; width: 55%; text-align: center; }
.fa-btn-primary:hover { opacity: 0.88; }
.fa-btn-sec { font-size: 13px; font-weight: 400; text-decoration: none; color: var(--muted); border: 1px solid var(--border); padding: 13px 22px; border-radius: 8px; transition: border-color 0.18s; }
.fa-btn-sec:hover { border-color: rgba(255,255,255,0.2); }

/* CARDS */
.right-col { display: flex; flex-direction: column; gap: 16px; }
.pro-card { background: var(--card-bg); border: 1px solid var(--border); border-radius: 14px; overflow: hidden; backdrop-filter: blur(10px); }
.pro-stripe { height: 3px; }
.lo-stripe { background: linear-gradient(90deg, var(--p), color-mix(in srgb, var(--p) 60%, #3a6ff5)); }
.re-stripe { background: linear-gradient(90deg, var(--a), color-mix(in srgb, var(--a) 60%, #f5c03a)); }
.pro-inner { display: flex; gap: 14px; align-items: center; padding: 18px; }
.pro-img-wrap { position: relative; flex-shrink: 0; }
.pro-img { width: 54px; height: 54px; border-radius: 50%; object-fit: cover; display: block; }
.pro-ring { position: absolute; inset: -3px; border-radius: 50%; border: 2px solid; }
.lo-ring { border-color: color-mix(in srgb, var(--p) 60%, #3a6ff5); }
.re-ring { border-color: var(--a); }
.pro-tag { font-size: 9px; font-weight: 600; letter-spacing: 0.18em; text-transform: uppercase; color: var(--muted); display: block; margin-bottom: 4px; }
.re-tag { color: color-mix(in srgb, var(--a) 80%, #f5c03a); }
.pro-name { font-size: 15px; font-weight: 600; color: #f0f4ff; }
.pro-title { font-size: 11px; color: var(--muted); }
.pro-nmls { font-size: 10px; color: color-mix(in srgb, var(--muted) 60%, transparent); margin-top: 2px; }
.pro-footer { padding: 10px 18px 16px; border-top: 1px solid var(--border); display: flex; flex-direction: column; gap: 4px; }
.pro-contact { font-size: 11px; text-decoration: none; color: var(--muted); transition: color 0.18s; }
.lo-ct:hover { color: color-mix(in srgb, var(--p) 80%, #aac); }
.re-ct:hover { color: var(--a); }
.pro-apply { display: block; margin-top: 8px; text-align: center; text-decoration: none; font-size: 12px; font-weight: 600; background: var(--a); color: #0d0e1a; padding: 10px; border-radius: 7px; transition: opacity 0.2s; }
.pro-apply:hover { opacity: 0.88; }

@media (max-width: 820px) {
  .mag-grid { grid-template-columns: 1fr; padding: 40px 24px; }
  .header { padding: 16px 24px; }
  .header-center { display: none; }
}
</style>
